import { render, staticRenderFns } from "./ConfigTableSkeletonSort.vue?vue&type=template&id=3c28dddf&scoped=true"
import script from "./ConfigTableSkeletonSort.vue?vue&type=script&lang=js"
export * from "./ConfigTableSkeletonSort.vue?vue&type=script&lang=js"
import style0 from "./ConfigTableSkeletonSort.vue?vue&type=style&index=0&id=3c28dddf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c28dddf",
  null
  
)

export default component.exports